import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const pageNames = {
  '/': 'Home',
  '/about': 'About Us',
  '/pricing': 'Pricing',
  '/memberships': 'Memberships',
  '/leagues': 'Leagues',
  '/lessons': 'Lessons',
  '/sportsbar': 'Sportsbar',
  '/events': 'Private Events',
  '/contact': 'Contact',
  '/courses': 'Courses',
  '/menu': 'Menu',
  '/gift-cards': 'Gift Cards',
  '/faq': 'FAQ',
  '/whats-new': "What's New",
  '/contest': 'Contest',
  '/privacy': 'Privacy Policy',
  '/terms': 'Terms of Service',
};

const Breadcrumb = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const currentPageName = pageNames[currentPath] || 'Page';

  useEffect(() => {
    // Don't add breadcrumb schema on home page
    if (currentPath === '/') return;

    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://pinhighbay.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": currentPageName,
          "item": `https://pinhighbay.com${currentPath}`
        }
      ]
    };

    // Add schema to head
    let script = document.querySelector('#breadcrumb-schema');
    if (!script) {
      script = document.createElement('script');
      script.id = 'breadcrumb-schema';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(breadcrumbSchema);

    // Cleanup on unmount
    return () => {
      const existingScript = document.querySelector('#breadcrumb-schema');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [currentPath, currentPageName]);

  // Don't render breadcrumb on home page
  if (currentPath === '/') return null;

  return (
    <nav aria-label="Breadcrumb" className="bg-gray-100 py-3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ol className="flex items-center space-x-2 text-sm">
          <li>
            <Link 
              to="/" 
              className="text-gray-500 hover:text-green-600 transition-colors flex items-center"
            >
              <Home className="w-4 h-4" />
              <span className="sr-only">Home</span>
            </Link>
          </li>
          <li>
            <ChevronRight className="w-4 h-4 text-gray-400" />
          </li>
          <li>
            <span className="text-gray-900 font-medium" aria-current="page">
              {currentPageName}
            </span>
          </li>
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;
